import classNames from 'classnames/bind';
import React from 'react';

import styles from './Bar.module.scss';

const cx = classNames.bind(styles);

const Bar = ({ size = 12, horizontal = false }) => {
  const style = {};
  if (horizontal) {
    style.width = size;
  } else {
    style.height = size;
  }

  return <div className={cx(['container', { horizontal }])} style={style} />;
};

export default Bar;
